import { configureStore } from "@reduxjs/toolkit";
import accessReducer from "./slices/accessSlice";
import appStateReducer from "./slices/appStateSlice";
import dishesReducer from "./slices/dishesSlice";
import doorReducer from "./slices/doorSlice";
import fridgeInfoReducer from "./slices/fridgeInfoSlice";
import fridgeLightingReducer from "./slices/fridgeLightingSlice";
import { doorOpenedMiddleware } from "./slices/middleware/doorOpenedMiddleware";
import { stateDebugMiddleware } from "./slices/middleware/stateDebugMiddleware";
import { userPreferencesMiddleware } from "./slices/middleware/userPreferencesMiddleware";
import transactionReducer from "./slices/transactionSlice";

/**
 * Builds a fresh Redux store. Used once at module init for the singleton `store`
 * and reused by tests via `makeStore()` for per-test isolation.
 */
export const makeStore = () =>
	configureStore({
		reducer: {
			access: accessReducer,
			appState: appStateReducer,
			dishes: dishesReducer,
			door: doorReducer,
			transaction: transactionReducer,
			fridgeInfo: fridgeInfoReducer,
			lighting: fridgeLightingReducer,
		},
		middleware: (getDefaultMiddleware) =>
			getDefaultMiddleware().concat(doorOpenedMiddleware, userPreferencesMiddleware, stateDebugMiddleware),
	});

export const store = makeStore();

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
